import { JobSeekerJobPositionAssignmentNode } from "@graphql/generated";
import { create } from "zustand";

interface IJobSuggestionStoreState {
  jobSuggestion?: JobSeekerJobPositionAssignmentNode | null;
  isLoading: boolean;
}

interface IJobSuggestionStoreActions {
  setJobSuggestion: (data: JobSeekerJobPositionAssignmentNode) => void;
  setIsLoading: (isLoading: boolean) => void;
}

type TJobSuggestionStore = IJobSuggestionStoreState & IJobSuggestionStoreActions;

const initialState: IJobSuggestionStoreState = {
  jobSuggestion: null,
  isLoading: false,
};

export const useJobSuggestionStore = create<TJobSuggestionStore>((set) => ({
  ...initialState,
  setJobSuggestion: (data) => set({ jobSuggestion: data }),
  setIsLoading: (isLoading) => set({ isLoading }),
}));
